import React from 'react';

import {
  Box,
  Grid,
  Typography
} from '@mui/material';

const NotFound = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Grid
        container
        justifyContent="center"
        spacing={4}
      >
        <Grid
          size={{
            xs: 12,
            lg: 6
          }}
        >
          <Box
            sx={{
              pt: '150px',
              textAlign: 'center'
            }}
          >
            <Typography variant="h1">
              404: The page you are looking for isn’t here
            </Typography>

            <Typography variant="subtitle2">
              You either tried some shady route or you came here by mistake.
              Whichever it is, try using the navigation.
            </Typography>

            <Box
              alt="Under development"
              component="img"
              src="/images/undraw_page_not_found_su7k.svg"
              sx={{
                display: 'inline-block',
                mt: '50px',
                maxWidth: '100%',
                width: 560
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotFound;